import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// components
import Button3d from '../../../../components/ButtonWrapper/components/Button3d';
import Chat from '../../../../components/Chat';
import LastActions from '../../../../components/LastActions';
import NextActions from '../../../../components/NextActions';

const CommCenterProjects = () => {
    const [tabState, setTabState] = useState('nextActions')

    return (
        <div className="appCommCenter">
            <div className="appWorkbenchPanel commCenterPanel">
                <Button3d
                    changeFn={() => setTabState('nextActions')}
                    name="nextActions"
                    checked={tabState === 'nextActions'}>
                    {__('Prossime Azioni', 'soundbetween')}
                </Button3d>
                {/*<Button3d
                    changeFn={() => setTabState('chat')}
                    name="chat"
                    checked={tabState === 'chat'}>
                    {__('Communicazioni', 'soundbetween')}
                </Button3d>*/}
            </div>
            <div className="appDashboard__workbench">
                {tabState === 'nextActions' ? <NextActions/> : <Chat type="CUSTOMER"/>}
            </div>
        </div>
    )
}

export default CommCenterProjects;